/* Verfijnde nieuws-slider: prev/next-knoppen, paging-dots en rand-fade.
   Progressive enhancement bovenop een native scroll-snap slider. */
if (!customElements.get('news-slider')) {
  customElements.define(
    'news-slider',
    class NewsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.news-list--slider');
        if (!this.track) return;
        this.slides = Array.from(this.track.children);
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.dotsWrap = this.querySelector('[data-dots]');

        if (this.slides.length <= 1) {
          this.classList.add('is-single');
          return;
        }

        this._buildDots();
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._step(-1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._step(1));

        this._ticking = false;
        this.track.addEventListener(
          'scroll',
          () => {
            if (this._ticking) return;
            this._ticking = true;
            requestAnimationFrame(() => {
              this._update();
              this._ticking = false;
            });
          },
          { passive: true }
        );
        window.addEventListener('resize', () => this._update());
        this._update();
      }

      _behavior() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      }

      _buildDots() {
        this.dots = [];
        if (!this.dotsWrap) return;
        this.dots = this.slides.map((slide, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'news-slider__dot';
          b.setAttribute('aria-label', 'Ga naar bericht ' + (i + 1));
          b.addEventListener('click', () => this._scrollTo(slide));
          this.dotsWrap.appendChild(b);
          return b;
        });
      }

      _animateTo(left) {
        const track = this.track;
        const start = track.scrollLeft;
        const target = Math.max(0, Math.min(left, track.scrollWidth - track.clientWidth));
        const dist = target - start;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || Math.abs(dist) < 1) {
          track.scrollLeft = target;
          return;
        }
        // Handmatige animatie: native smooth-scroll wordt door scroll-snap
        // onderbroken ("verspringen"). We animeren scrollLeft zelf via rAF en
        // zetten snap tijdelijk uit tot de animatie klaar is.
        track.style.scrollSnapType = 'none';
        if (this._raf) cancelAnimationFrame(this._raf);
        const duration = 420;
        const ease = function (t) {
          return 1 - Math.pow(1 - t, 3);
        };
        const self = this;
        let startTs = null;
        const step = function (ts) {
          if (startTs === null) startTs = ts;
          const p = Math.min((ts - startTs) / duration, 1);
          track.scrollLeft = start + dist * ease(p);
          if (p < 1) {
            self._raf = requestAnimationFrame(step);
          } else {
            self._raf = null;
            track.style.scrollSnapType = '';
          }
        };
        this._raf = requestAnimationFrame(step);
      }

      _scrollTo(slide) {
        const delta = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this._animateTo(this.track.scrollLeft + delta);
      }

      _step(dir) {
        const gap = 16;
        const w = this.slides[0].getBoundingClientRect().width + gap;
        this._animateTo(this.track.scrollLeft + dir * w);
      }

      _active() {
        const trackLeft = this.track.getBoundingClientRect().left;
        let idx = 0;
        let min = Infinity;
        this.slides.forEach((s, i) => {
          const d = Math.abs(s.getBoundingClientRect().left - trackLeft);
          if (d < min) {
            min = d;
            idx = i;
          }
        });
        return idx;
      }

      _update() {
        const idx = this._active();
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        if (this.prevBtn) this.prevBtn.disabled = atStart;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;
        this.classList.toggle('is-start', atStart);
        this.classList.toggle('is-end', atEnd);
      }
    }
  );
}
